import React from "react";

const TabletMode = React.lazy(
  () => import("./views/kalasanPages/pengaturan/tabletMode/tabletMode"),
);
const HistoriPenerimaan = React.lazy(
  () => import("./views/kalasanPages/tablet/penerimaan/historiPenerimaan"),
);
const Stock = React.lazy(
  () => import("./views/kalasanPages/tablet/stok/stokTablet/Stok"),
);
const PenerimaanUdangKelong = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/udang-kelong/penerimaanUdangKelong"),
);
const PenerimaanUdangKelongV2 = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/udang-kelong-v2/penerimaanUdangKelongV2"),
);

const DaftarProdukSetengahJadi = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/spkProdukSetengahJadi/DaftarProdukSetengahJadi"),
);

const ListPenerimaan = React.lazy(
  () => import("./views/kalasanPages/tablet/list-penerimaan/ListPenerimaan"),
);

const PenerimaanAyamSate = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/ayam-sate/penerimaanAyamSate"),
);
const PenerimaanAyamKalasan = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/ayam-kalasan/penerimaanAyamKalasan"),
);
const PenerimaanAyamKari = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/ayam-kari/penerimaanAyamKari"),
);
const PenerimaanAyamPenyet = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/ayam-penyet/penerimaanAyamPenyet"),
);
const PenerimaanUdangGalah = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/udang-galah/penerimaanUdangGalah"),
);
const PenerimaanCumi = React.lazy(
  () => import("./views/kalasanPages/tablet/penerimaan/cumi/penerimaanCumi"),
);
const PenerimaanDLL = React.lazy(
  () => import("./views/kalasanPages/tablet/penerimaan/dll/penerimaanDLL"),
);
const PenerimaanIkanKakap = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/ikan-kakap/penerimaanIkanKakap"),
);
const PenerimaanIkanBawal = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/ikan-bawal/penerimaanIkanBawal"),
);
const PenerimaanIkanKaryawan = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/ikan-karyawan/penerimaanIkanKaryawan"),
);
const PenerimaanIkanGurami = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/ikan-gurami/penerimaanIkanGurami"),
);
const PenerimaanKelapaTua = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/kelapa-tua/penerimaanKelapaTua"),
);
const PenerimaanSayap = React.lazy(
  () => import("./views/kalasanPages/tablet/penerimaan/sayap/penerimaanSayap"),
);

/// BAGIAN PRODUKSI =====
const ProduksiIkanGurami = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/produksi/ikan-gurami/produksiIkanGurami"),
);
const ProduksiCumi = React.lazy(
  () => import("./views/kalasanPages/tablet/produksi/cumi/produksiCumi"),
);
const ProduksiUdangKelong = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/produksi/udang-kelong/produksiUdangKelong"),
);
const PenerimaanDendengSapi = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/penerimaan/dendeng-sapi/penerimaanDendengSapi"),
);
const ProduksiIkanKakap = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/produksi/ikan-kakap/ProduksiIkanKakap"),
);
const ProduksiIkanKaryawan = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/produksi/ikan-karyawan/ProduksiIkanKaryawan"),
);
const ProduksiAyamSate = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/produksi/ayam-sate/ProduksiAyamSate"),
);
const BarangJadi = React.lazy(
  () => import("./views/kalasanPages/tablet/barangJadi/BarangJadi"),
);
const BarangSetengahJadi = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/barangSetengahJadi/BarangSetengahJadi"),
);
const DaftarSPK = React.lazy(
  () => import("./views/kalasanPages/tablet/produksiSPK/daftarSpk/DaftarSPK"),
);
const PenyiapanBahan = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/produksiSPK/penyiapanBahan/PenyiapanBahanTablet"),
);
const MutasiGudang = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/stok/mutasigudang/MutasiGudangTablet"),
);
const Kolam = React.lazy(
  () => import("./views/kalasanPages/tablet/stok/kolam/KolamTablet"),
);
const DetailRekapPermintaanGudang = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/stok/detailRekapPermintaanGudang/DetailRekapPermintaanGudangTablet"),
);
const PermintaanPusat = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/permintaan/permintaanPusat/PermintaanPusatTablet"),
);
const PermintaanCabang = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/permintaan/permintaanCabang/PermintaanCabangTablet"),
);
const RekapPermintaanCabang = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/permintaan/rekapPermintaanCabang/RekapPermintaanCabangTablet"),
);
const PermintaanBarangPajak = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/permintaan/permintaanBarangPajak/PermintaanBarangPajakTablet"),
);
const PermintaanReservasiPaket = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/permintaan/permintaanReservasiPaket/PermintaanReservasiPaketTablet"),
);
const RekapPermintaanGudang = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/rekapPermintaanGudang/RekapPermintaanGudangTablet"),
);
const SuratJalan = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/pengiriman/suratJalan/SuratJalanTablet"),
);
const CeklisPengiriman = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/pengiriman/ceklisPengiriman/CeklisPengirimanTablet"),
);
const BarangHilang = React.lazy(
  () =>
    import("./views/kalasanPages/tablet/dll/barangHilang/BarangHilangTablet"),
);

const routesKitchen = [
  {
    path: "/tablet-mode",
    exact: true,
    name: "Mode Tablet",
    component: TabletMode,
  },
  {
    path: "/tablet-mode/histori-penerimaan",
    name: "Histori Penerimaan",
    component: HistoriPenerimaan,
  },
  {
    path: "/tablet-mode/stok",
    name: "Stok Tablet",
    component: Stock,
  },
  {
    path: "/tablet-mode/penerimaan-udang-kelong",
    name: "Penerimaan Udang Kelong",
    component: PenerimaanUdangKelong,
  },
  {
    path: "/tablet-mode/penerimaan-udang-kelong-v2",
    name: "Penerimaan Udang Kelong V2",
    component: PenerimaanUdangKelongV2,
  },
  {
    path: "/tablet-mode/penerimaan-ayam-sate",
    name: "Penerimaan Ayam Sate",
    component: PenerimaanAyamSate,
  },
  {
    path: "/tablet-mode/penerimaan-ayam-kalasan",
    name: "Penerimaan Ayam Kalasan",
    component: PenerimaanAyamKalasan,
  },
  {
    path: "/tablet-mode/penerimaan-ayam-kari",
    name: "Penerimaan Ayam Kari",
    component: PenerimaanAyamKari,
  },
  {
    path: "/tablet-mode/penerimaan-ayam-penyet",
    name: "Penerimaan Ayam Penyet",
    component: PenerimaanAyamPenyet,
  },
  {
    path: "/tablet-mode/penerimaan-udang-galah",
    name: "Penerimaan Udang Galah",
    component: PenerimaanUdangGalah,
  },
  {
    path: "/tablet-mode/penerimaan-cumi",
    name: "Penerimaan Cumi",
    component: PenerimaanCumi,
  },
  {
    path: "/tablet-mode/penerimaan-dendeng-sapi",
    name: "Penerimaan Dendeng Sapi",
    component: PenerimaanDendengSapi,
  },
  {
    path: "/tablet-mode/penerimaan-dll",
    name: "Penerimaan DLL",
    component: PenerimaanDLL,
  },
  {
    path: "/tablet-mode/penerimaan-ikan-kakap",
    name: "Penerimaan Ikan Kakap",
    component: PenerimaanIkanKakap,
  },
  {
    path: "/tablet-mode/penerimaan-ikan-bawal",
    name: "Penerimaan Ikan Bawal",
    component: PenerimaanIkanBawal,
  },
  {
    path: "/tablet-mode/penerimaan-ikan-karyawan",
    name: "Penerimaan Ikan Karyawan",
    component: PenerimaanIkanKaryawan,
  },
  {
    path: "/tablet-mode/penerimaan-ikan-gurami",
    name: "Penerimaan Ikan Gurami",
    component: PenerimaanIkanGurami,
  },
  {
    path: "/tablet-mode/penerimaan-kelapa-tua",
    name: "Penerimaan Kelapa Tua",
    component: PenerimaanKelapaTua,
  },
  {
    path: "/tablet-mode/penerimaan-sayap",
    name: "Penerimaan Sayap",
    component: PenerimaanSayap,
  },

  // PRODUKSI ========== [AYAM SATE, IKAN KAKAP, IKAN GURAME, IKAN KARYAWAN, UDANG KELONG, CUMI]
  {
    path: "/tablet-mode/produksi-ikan-gurami",
    name: "Produksi Ikan Gurami",
    component: ProduksiIkanGurami,
  },
  {
    path: "/tablet-mode/produksi-cumi",
    name: "Produksi Cumi",
    component: ProduksiCumi,
  },
  {
    path: "/tablet-mode/produksi-udang-kelong",
    name: "Produksi Udang Kelong",
    component: ProduksiUdangKelong,
  },
  {
    path: "/tablet-mode/produksi-ikan-kakap",
    name: "Produksi Ikan Kakap",
    component: ProduksiIkanKakap,
  },
  {
    path: "/tablet-mode/produksi-ikan-karyawan",
    name: "Produksi Ikan Karyawan",
    component: ProduksiIkanKaryawan,
  },
  {
    path: "/tablet-mode/produksi-ayam-sate",
    name: "Produksi Ayam Sate",
    component: ProduksiAyamSate,
  },
  // ====================

  // SPK product setengah jadi
  {
    path: "/tablet-mode/spk-produk-setengah-jadi",
    name: "SPK Produk Setengah Jadi",
    component: DaftarProdukSetengahJadi,
  },
  {
    path: "/tablet-mode/daftar-spk",
    name: "Daftar SPK",
    component: DaftarSPK,
  },
  {
    path: "/tablet-mode/penyiapan-bahan",
    name: "Penyiapan Bahan",
    component: PenyiapanBahan,
  },

  // Stok
  {
    path: "/tablet-mode/mutasi-gudang",
    name: "Mutasi Gudang",
    component: MutasiGudang,
  },
  {
    path: "/tablet-mode/kolam",
    name: "Kolam",
    component: Kolam,
  },
  {
    path: "/tablet-mode/detail-rekap-permintaan-gudang",
    name: "Detail Rekap Permintaan Gudang",
    component: DetailRekapPermintaanGudang,
  },

  // ceklist penerimaan barang (sebelum ke penerimaan untuk handle reject dan approve)
  {
    path: "/tablet-mode/list-penerimaan",
    name: "Ceklist Penerimaan Barang",
    component: ListPenerimaan,
  },

  {
    path: "/tablet-mode/produksi-barang-jadi",
    name: "Produksi Barang Jadi",
    component: BarangJadi,
  },
  {
    path: "/tablet-mode/produksi-barang-setengah-jadi",
    name: "Produksi Barang Setengah Jadi",
    component: BarangSetengahJadi,
  },
  {
    path: "/tablet-mode/permintaan-pusat",
    name: "Permintaan Pusat",
    component: PermintaanPusat,
  },
  {
    path: "/tablet-mode/permintaan-cabang",
    name: "Permintaan Cabang",
    component: PermintaanCabang,
  },
  {
    path: "/tablet-mode/rekap-permintaan-cabang",
    name: "Rekap Permintaan Cabang",
    component: RekapPermintaanCabang,
  },
  {
    path: "/tablet-mode/permintaan-barang-pajak",
    name: "Permintaan Barang Pajak",
    component: PermintaanBarangPajak,
  },
  {
    path: "/tablet-mode/permintaan-reservasi-paket",
    name: "Permintaan Reservasi Paket",
    component: PermintaanReservasiPaket,
  },
  {
    path: "/tablet-mode/rekap-permintaan-gudang",
    name: "Rekap Permintaan Gudang",
    component: RekapPermintaanGudang,
  },

  // Surat Jalan
  {
    path: "/tablet-mode/surat-jalan",
    name: "Surat Jalan",
    component: SuratJalan,
  },
  {
    path: "/tablet-mode/ceklis-pengiriman",
    name: "Ceklis Pengiriman",
    component: CeklisPengiriman,
  },

  // DLL
  {
    path: "/tablet-mode/barang-hilang",
    name: "Barang Hilang",
    component: BarangHilang,
  },
];

export default routesKitchen;
